






























import Vue from "vue"
import {INewsService, newsService} from "@/model/service/news/news-service"
import moment from "moment"
import {AxiosResponse} from "axios"
import {News} from "@/model/entity/news/news"
import {Page} from "@/model/dto/page"
import "quill/dist/quill.core.css"
import {Filter} from "@/model/dto/filter"

interface HomeData {
  newsList: News[]
  newsService: INewsService
  page: number
  total: number
}

export default Vue.extend({
  data(): HomeData {
    return {
      newsList: [],
      newsService: newsService,
      page: 1,
      total: 0
    }
  },
  methods: {
    onScroll(e: any, scroll: any) {
      const newsPanelHeight = (this.$refs.news_panel as any).clientHeight
      const newsPanelWrapperHeight = (this.$refs.news_panel_wrapper as any).clientHeight
      const scrollTop = scroll.scrollTop
      if (
        newsPanelWrapperHeight - (newsPanelHeight + scrollTop) < 200 &&
        !this.$store.state.loading &&
        this.newsList.length < this.total
      ) {
        this.getNews()
      }
    },
    prettyDate(date: number) {
      return moment(date).format("DD.MM.YYYY")
    },
    getNews() {
      const vm = this
      vm.startLoad()
      const filters = []
      filters.push(new Filter("active", "true"))
      vm.newsService
        .getPage(vm.page, 5, filters)
        .then((response: AxiosResponse<Page<News>>) => {
          vm.endLoad()
          vm.newsList = vm.newsList.concat(response.data.content)
          vm.total = response.data.totalElements
          vm.page++
        })
        .catch(() => {
          vm.endLoad()
        })
    }
  },
  created() {
    this.getNews()
  }
})
